import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';

import UIStore from '../stores/UIStore';
import UserStore from '../stores/UserStore';
import Feedback from 'components/Feedback';

import { LoginForm } from '../components/LoginForm';

import { useQueryParameters } from '@partsbadger/utils';
import { useHistory } from 'react-router';

import AuthLayout from 'components/AuthLayout';
import { Card, Col, Row, Tag, Typography } from 'antd';
import UTMQueryPreservingLink from '../common/UTMQueryPreservingLink';
import RedirectPreservingUTMQuery from '../common/RedirectPreservingUTMQuery';

const PortalAuth = () => {
    const query = useQueryParameters();
    const feedback_sales_order_name = query.get('feedback_sales_order');

    const next_url = query.get('next') || '/my-account/';
    const history = useHistory();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const redirectToPortal = () => {
        history.push('/my-account/');
    };

    useEffect(() => {
        if (feedback_sales_order_name) {
            setIsModalVisible(true);
        } else {
            UIStore.setSelectedKey(['my-account']);
            UIStore.setDocumentTitle('Login');
        }
    }, []);

    if (UserStore.isAuthenticated && !feedback_sales_order_name) {
        return <RedirectPreservingUTMQuery to={next_url} />;
    }

    const menuButtons = [
        {
            title: 'Submit a Quote',
        },
        {
            title: 'Check Order Status',
        },
        {
            title: 'Reorder',
        },
        {
            title: 'Add Requirements',
        },
        {
            title: 'Add Documents',
        },
        {
            title: 'View Product History',
        },
        {
            title: 'View Invoices',
        },
        {
            title: 'Access Support',
        },
        {
            title: 'Use Latest Features',
        },
    ];

    return (
        <>
            <Feedback
                isSalesOrder={true}
                name={feedback_sales_order_name ?? ''}
                visible={isModalVisible}
                setVisible={setIsModalVisible}
                redirectToThisPage={() => redirectToPortal()}
            />
            <Row justify="center">
                <Col>
                    <Typography.Title level={1} className="py-5">
                        Welcome!
                    </Typography.Title>
                </Col>
            </Row>
            <Row justify="center">
                <Col xs={22} sm={22} md={22} lg={22} xl={18} xxl={14} span={24}>
                    <p>
                        This platform is designed to provide you with easy access to your account with PartsBadger.
                        Whether you're looking to submit a quote, place an order, track a shipment, or get in touch with
                        our support team, our portal is the place to be. Thank you for choosing us as your partner and
                        we look forward to serving you.
                    </p>
                </Col>
            </Row>
            <Row justify="center">
                <Col xs={22} sm={22} md={22} lg={22} xl={18} xxl={14} span={24}>
                    <Typography.Title level={3} className="py-2">
                        What can you do here?
                    </Typography.Title>
                    {menuButtons.map(item => {
                        return (
                            <Tag className="m-2" key={item.title}>
                                {item.title}
                            </Tag>
                        );
                    })}
                </Col>
            </Row>

            <Row justify="center">
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={7} span={12}>
                    <Card className="p-4 m-5 shadow-xl py-5" style={{ minHeight: '510px' }}>
                        <Typography.Title level={1}>No Account Yet? No Problem!</Typography.Title>

                        <p>You can start a quote here:</p>

                        <UTMQueryPreservingLink to={`/rapid-quote/start/`} className="ant-btn ant-btn-primary w-100">
                            Get Quote
                        </UTMQueryPreservingLink>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={7} span={12}>
                    <Card className="p-4 m-5 shadow-xl py-5">
                        <AuthLayout
                            handleLogin={() => {
                                const searchParams = new URLSearchParams(location.search);
                                // Remove the 'next' parameter from the URL
                                searchParams.delete('next');
                                history.replace(`${next_url}?${searchParams.toString()}`);
                            }}
                        />
                        {/* <LoginForm
                                handleLogin={() => {
                                history.replace(next_url);
                            }}
                        /> */}
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default observer(PortalAuth);
